import { ApiCallResponse } from '@kts-front/call-api';

export const isCancelledRequest = (response: ApiCallResponse<any, any>): boolean => {
  return 'isCancelled' in response && response.isCancelled;
};
